import { z } from "@/zod";
import {
  readShiftReportDepartmentEntry,
  writeShiftReportDepartmentEntry,
} from "@/schemas/shiftReportDepartmentEntry";

const shiftReport = z.object({
  id: z.string().length(26),
  shift: z.string(),
  shift_date: z.string().date(),
  shift_id: z.string(),
  shift_name: z.string(),
  store_id: z.string(),
  store_name: z.string(),
  comments: z.string().max(1000).optional(),
  department_entries: z.array(readShiftReportDepartmentEntry),
});

export const readShiftReport = shiftReport.readonly();

export const writeShiftReportBase = shiftReport
  .omit({
    id: true,
    shift: true,
    shift_date: true,
    shift_id: true,
    shift_name: true,
    store_id: true,
    store_name: true,
  })
  .extend({
    department_entries: z.array(writeShiftReportDepartmentEntry),
  });

export const writeShiftReport = writeShiftReportBase.transform((data) => ({
  ...data,
  department_entries: data.department_entries.map((entry) => ({
    ...entry,
    ordered: entry.ordered ?? 0,
    present: entry.present ?? 0,
  })),
}));
